export const HEAT_LAYER_OPACITY = 0.6;

export const colorForRatio = (ratio) => {
    const t = Math.max(0, Math.min(1, ratio));
    const channel = Math.round(220 * (1 - t));
    return `rgb(255,${channel},${channel})`;
};
